import axios, { AxiosError } from "axios";
const ConsignmentAssignedVehicleResource = {
    assignVehicleToConsignment(consignmentId, request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/consignments/${consignmentId}/assigned-vehicles`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    }
};
export default ConsignmentAssignedVehicleResource;
